/* @flow */
import React, { useContext, useState, memo } from 'react'
import S from './Header13.styled'
import THEME from './Header13.theme'
import ActionGetter from './Actions'
import NavBar from '@website/common/components/NavBar'
import { validation } from './Header13.consts'
import { DispatchContext, EditingContext } from '@contexts'
import EditableContent from '@website/common/components/EditableContent'
import Show from '@website/common/components/Show/Show'
import { scrollBottom } from '@website/common/utils'
import If from '@website/common/components/Conditional'
import Buttons from '@website/common/components/Buttons'
import SocialLinks from '@website/common/components/SocialLinks'

const Header13 = memo(props => {
  const {
    data: {
      title,
      paragraph,
      titleAlignment,
      paragraphAlignment,
      logoSrc,
      logoColor,
      backgroundImgUrl,
      buttons,
      headerSocials,
      logoWidth,
      logoDimensions,
      bgOverlayTransparency,
      backgroundImgDimensions
    },
    hasNextComponent
  } = props
  const dispatcher = useContext(DispatchContext)
  const Actions = ActionGetter(dispatcher)
  const { isEditing } = useContext(EditingContext)
  const [navBarHeight, setNavBarHeight] = useState(0)

  return (
    <S.StyledContainer
      isEditing={isEditing}
      backgroundImgUrl={backgroundImgUrl}
      bgOverlayTransparency={bgOverlayTransparency}
      isSocials={headerSocials.length > 4}
      backgroundImgDimensions={backgroundImgDimensions}
    >
      <NavBar
        handleHeightChange={setNavBarHeight}
        theme={THEME}
        logoProps={{
          logoSrc,
          logoColor,
          logoWidth,
          logoSizes: logoDimensions
        }}
      />
      <Show when={[title, paragraph, buttons.length > 0]}>
        <S.WmCustomContainer topOffset={navBarHeight}>
          <S.HeaderContent>
            <EditableContent
              text={title}
              alignment={titleAlignment}
              required={validation.title.required}
              maxCount={validation.headingMaxChar}
              className="WM_GLOBAL_heading96"
              as={S.Title}
              onChange={Actions.changeTitle}
              changeAlignment={Actions.changeTitleAlignment}
            />
            <Show when={[title]}>
              <S.Divider />
            </Show>
            <EditableContent
              text={paragraph}
              as={S.Description}
              alignment={paragraphAlignment}
              maxCount={validation.paragraphMaxChar}
              className="WM_GLOBAL_paragraph"
              onChange={Actions.changeParagraph}
              changeAlignment={Actions.changeParagraphAlignment}
            />
            <Buttons data={buttons} />
          </S.HeaderContent>
        </S.WmCustomContainer>
      </Show>
      <SocialLinks
        className="header-socials"
        socials={headerSocials}
        socialsMaxCount={validation.headerSocials.max}
      />
      <If
        condition={hasNextComponent}
        then={() => (
          <S.DownButton
            role="button"
            onClick={() => scrollBottom(isEditing)}
            aria-label="Scroll down button"
          >
            <S.ScrollIcon size="xlarge" name="icon-arrow_small_bottom" />
          </S.DownButton>
        )}
      />
    </S.StyledContainer>
  )
})

Header13.contextType = DispatchContext

export default Header13
